import type { ComponentType } from 'react'
import { AuditSection } from './sections/AuditSection'
import { FrentesSection } from './sections/FrentesSection'
import { IntegrationsSection } from './sections/IntegrationsSection'
import { OrgSection } from './sections/OrgSection'
import { PermissionsSection } from './sections/PermissionsSection'
import { RulesSection } from './sections/RulesSection'
import { UsersSection } from './sections/UsersSection'
import { adminOnly } from './ui'

/* ERP · seções das Configurações do ERP (agente das configurações). Cada uma vira /configuracoes/<chave> e um item no
   menu das Configurações (grupo), junto com as telas do antigo espaço Admin (Operação, Agentes, Sistema).
   Todas só para admin (adminOnly mostra o aviso para os outros perfis). */
export type ConfigSection = { key: string; label: string; group: 'Pessoas' | 'ERP' | 'Segurança' | 'Organização'; component: ComponentType }

const section = (key: string, label: string, group: ConfigSection['group'], component: ComponentType): ConfigSection => ({ key, label, group, component: adminOnly(component) })

export const CONFIG_SECTIONS: ConfigSection[] = [
    section('usuarios', 'Usuários e acessos', 'Pessoas', UsersSection),
    section('permissoes', 'Permissões e dados pessoais', 'Pessoas', PermissionsSection),
    section('frentes', 'Frentes e telas', 'ERP', FrentesSection),
    section('regras', 'Regras e alertas', 'ERP', RulesSection),
    section('integracoes', 'Integrações', 'ERP', IntegrationsSection),
    section('auditoria', 'Auditoria', 'Segurança', AuditSection),
    section('organizacao', 'Dados da organização', 'Organização', OrgSection),
]
